// extracted by mini-css-extract-plugin
module.exports = {"address-form":"AddressModal_address-form__1xbkr","title":"AddressModal_title__29qcB","header":"AddressModal_header__uoG2Y","save-btn":"AddressModal_save-btn__1KTN2"};